import { Bell, BookOpen, Building2, FileText, LayoutDashboard, LogOut, QrCode, ShieldCheck, UsersRound } from "lucide-react";
import { Button } from "@/components/ui/button";

const items = [
  { key: "dashboard", label: "Tableau", icon: LayoutDashboard },
  { key: "students", label: "Étudiants", icon: UsersRound },
  { key: "companies", label: "Entreprises", icon: Building2 },
  { key: "history", label: "Historique", icon: QrCode },
  { key: "alerts", label: "Alertes", icon: Bell },
  { key: "livret", label: "Livret de l'année", icon: FileText },
  { key: "fonctions", label: "Fonctions F1-F4", icon: BookOpen },
  { key: "accounts", label: "Comptes", icon: ShieldCheck, adminOnly: true },
];

export default function Sidebar({ view, setView, user, onLogout }) {
  return (
    <aside className="flex w-full flex-col border-b border-zinc-200 bg-white md:min-h-screen md:w-72 md:border-b-0 md:border-r" data-testid="app-sidebar">
      <div className="border-b border-zinc-200 p-5" data-testid="sidebar-brand-block">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#002FA7]" data-testid="sidebar-brand-kicker">FilStage</p>
        <p className="font-display text-2xl font-bold" data-testid="sidebar-brand-title">Présence BTS</p>
      </div>
      <nav className="flex gap-1 overflow-x-auto p-3 md:flex-1 md:flex-col md:gap-2 md:p-4" data-testid="sidebar-navigation">
        {items.filter((item) => !item.adminOnly || user?.role === "admin").map((item) => {
          const Icon = item.icon;
          const active = view === item.key;
          return (
            <button key={item.key} onClick={() => setView(item.key)} className={`flex min-w-fit items-center gap-3 border-l-4 px-4 py-3 text-left text-sm font-semibold transition-[background-color,transform,color,border-color] hover:-translate-y-px ${active ? "border-[#002FA7] bg-blue-50 text-[#002FA7]" : "border-transparent text-zinc-600 hover:bg-zinc-50"}`} data-testid={`sidebar-${item.key}-button`}>
              <Icon className="h-4 w-4" aria-hidden="true" />{item.label}
            </button>
          );
        })}
      </nav>
      <div className="border-t border-zinc-200 p-4" data-testid="sidebar-user-block">
        <p className="text-sm font-semibold" data-testid="sidebar-user-name">{user?.name}</p>
        <p className="text-xs text-zinc-500" data-testid="sidebar-user-role">{user?.organization}</p>
        <Button variant="outline" onClick={onLogout} className="mt-4 w-full rounded-none" data-testid="sidebar-logout-button"><LogOut className="h-4 w-4" />Déconnexion</Button>
      </div>
    </aside>
  );
}